import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import Button from '../../components/Button';
import Company from './Company';
import Process from './Process';
import NetMetering from './NetMetering';
import { Title, Subtitle } from './styles';

import '../../grid.css';
import './home.css';

class Dashboard extends Component {
    toggleProposalView() {
        const { setToggleView } = this.props;
        setToggleView(false);
    }

    render() {
        const {
            companyName,
            firstName,
        } = this.props;

        const projectType = companyName ? 'business' : 'home';

        return (
            <div>
                <section className="heroContainer">
                    <div className="heroBG" />
                    <div className="heroBGImg" />
                    <div className="heroContent">
                        <Title>Welcome to Solvana, {companyName || firstName}.</Title>
                        <Subtitle>
                            Let&#39;s start producing clean energy for your {projectType}.
                        </Subtitle>
                        <div className="heroBtnContainer">
                            <Button
                                fullWidth
                                size="large"
                                color="secondary"
                                variant="contained"
                                onClick={e => this.toggleProposalView(e)}
                            >
                                VIEW MY SOLAR BENEFITS
                            </Button>
                        </div>
                    </div>
                </section>

                <Process />

                <Company />

                <NetMetering />
            </div>
        );
    }
}

Dashboard.propTypes = {
    firstName: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    setToggleView: PropTypes.func.isRequired,
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js